var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{ref:"autocomplete",attrs:{"label":"World","value":_vm.value,"items":_vm.worlds,"filter":_vm.worldFilter,"item-text":"title","item-value":"_id","disabled":_vm.disabled,"loading":_vm.loading},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }